module.exports = __webpack_public_path__ + "static/media/rich_5250.png.8ee1ca18.webp";